import SimpleDate from 'app/dataProviders/SimpleDate'


export enum OperationTypeStatus {
  Unknown = -1,
  Accrual = 0, // 0: 'начисление компенсации',
  CancellationAccrual = 1, // 1: 'отмена начисления компенсации',
  WithdrawalCurrentAccount = 2, // 2: 'вывод по заявлению на р / с',
  WithdrawalPersonalAccount = 3, // 3: 'вывод на л / с',
  CancellationWithdrawalPersonalAccount = 4 // 'отмена вывода по заявлению на р / с'
}

export type Params = {
  studentID: string
  supplierID: string
  dateFrom: SimpleDate
  dateTo: SimpleDate
}

export type TransactionsType = {
  ID: string
  date: SimpleDate,
  value: number,
  operationType: number,
  comment: string
}
